import { Platform } from 'react-native';
import { N8nChatTarget } from './n8nChat/N8nChatButton.constants';

export const ChatButtonTarget = Platform.OS === 'web' ? N8nChatTarget : '';
